"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _InContextAlert = require("./InContextAlert");
Object.keys(_InContextAlert).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _InContextAlert[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _InContextAlert[key];
    }
  });
});